import { Modal } from '@fozito/common-ui';
import { Form } from 'antd';
import ModalActions from 'modules/POS/Cashier/components/ModalActions';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import { IFormDiscountValues, IUISelectItem } from '../../../cashier.interface';
import SalonDiscountTab, { DISCOUNT_FORM_TYPE, useSalonDiscountV2TabRef } from './SalonDiscountTab';
const FormStyled = styled(Form)``;
type Props = {};
type Ref = {
  open: (data: IUISelectItem, callback: (data: IUISelectItem, discount: { discountType: string, discountValue: number }) => void) => void;
};
export const useDiscountByItemRef = () => useRef<Ref>(null);
export const globalDiscountByItemRef = React.createRef<Ref>();
const DiscountByItem = forwardRef<Ref, Props>(({ }, ref) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const salonDiscountV2TabRef = useSalonDiscountV2TabRef();
  const callbackRef = useRef<(data: IUISelectItem, discount: { discountType: string, discountValue: number }) => void>(() => undefined);

  const onClose = () => setOpen(false);
  const onOpen: Ref['open'] = (data, _callback) => {
    form.resetFields();
    setOpen(true);
    form.setFieldsValue({
      data,
      discountValue: data.discount,
      discountType: DISCOUNT_FORM_TYPE.DOLLAR,
    });
    callbackRef.current = _callback || (() => undefined);
    setTimeout(() => {
      salonDiscountV2TabRef.current?.onActive();
    }, 100);
  };

  const handleFinish = (values: any) => {
    const data = values as IFormDiscountValues;
    const selected = values.data as IUISelectItem;
    callbackRef.current(selected, { discountType: data.discountType, discountValue: data.discountValue });
    onClose();
  };


  useImperativeHandle(ref, () => ({
    open: onOpen,
  }));

  if (!open) return null;

  return (
    <Modal title='Discount By Item' open={open} onClose={onClose} width={900}>
      <FormStyled form={form} onFinish={handleFinish}>
        <SalonDiscountTab
          form={form} ref={salonDiscountV2TabRef} active />
        <Form.Item name={'data'} noStyle />
        <ModalActions onClose={onClose} />
      </FormStyled>
    </Modal>
  );
});
DiscountByItem.displayName = 'DiscountByItem';
export default DiscountByItem;